import { render, staticRenderFns } from "./TableHeader.vue?vue&type=template&id=4ca97780&scoped=true&"
import script from "./TableHeader.vue?vue&type=script&lang=js&"
export * from "./TableHeader.vue?vue&type=script&lang=js&"
import style0 from "./TableHeader.vue?vue&type=style&index=0&id=4ca97780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca97780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ca97780')) {
      api.createRecord('4ca97780', component.options)
    } else {
      api.reload('4ca97780', component.options)
    }
    module.hot.accept("./TableHeader.vue?vue&type=template&id=4ca97780&scoped=true&", function () {
      api.rerender('4ca97780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/addresses/components/TableHeader.vue"
export default component.exports